<template>
  <div id="branchPage">
    <data-view-sidebar
      :isSidebarActive="addNewDataSidebar"
      @closeSidebar="toggleDataSidebar"
      :data="sidebarData"
    />
    <vs-popup
      class="holamundo"
      title="Şube Sil"
      :active.sync="deletePopupActive"
      v-esc="escape"
    >
      <vs-row vs-type="flex" vs-w="12">
        <p>Bu Şubeyi Silmek İstediğinize Eminmisiniz ?</p>
      </vs-row>
      <vs-row vs-type="flex" vs-w="12" class="mt-3" vs-justify="space-between">
        <vs-button
          type="gradient"
          color="primary"
          @click="
            deletePopupActive = false;
            deletedId = null;
          "
          >Vazgeç
        </vs-button>
        <vs-button
          type="gradient"
          color="danger"
          icon-pack="feather"
          icon="icon-trash"
          @click="deleteData(deletedId)"
        >
          Sil
        </vs-button>
      </vs-row>
    </vs-popup>
    <vs-popup
      class="holamundo"
      title="Şube Stok Sıfırla"
      :active.sync="resetPopupActive"
      v-esc="escape"
    >
      <vs-row vs-type="flex" vs-w="12">
        <p>
          Bu Şubenin tüm stoklarını sıfırlamak istediğinize eminmisiniz ? Bu
          işlem daha sonra geri alınamaz.
        </p>
      </vs-row>
      <vs-row vs-type="flex" vs-w="12" class="mt-3" vs-justify="space-between">
        <vs-button
          type="gradient"
          color="primary"
          @click="
            resetPopupActive = false;
            resetId = null;
          "
          >Vazgeç
        </vs-button>
        <vs-button
          type="gradient"
          class="text-light"
          color="warning"
          icon-pack="feather"
          icon="icon-rotate-ccw"
          @click="resetBranch(resetId)"
        >
          Sıfırla
        </vs-button>
      </vs-row>
    </vs-popup>
    <vs-table
      id="branchDataList"
      ref="table"
      :data="branches"
      :max-items="itemsPerPage"
      v-model="selected"
    >
      <div
        slot="header"
        class="w-full flex flex-wrap items-center flex-grow justify-between"
      >
        <vs-row vs-type="flex" vs-w="12" class="mb-1">
          <global-filter
            ref="filterer"
            :tableOptions="tableOptions"
            :filterOptions="filterOptions"
            :filterChips="filterChips"
            :filterOptionNames="filterOptionNames"
            :isActive="isFilterActive"
            @saveOptions="saveOptions"
            @close="isFilterActive = false"
          />
          <vs-row
            id="panelHeaderRow"
            v-show="!isFilterActive"
            vs-type="flex"
            vs-w="12"
            vs-justify="space-between"
          >
            <vs-col
              id="panel-actions"
              vs-type="flex"
              class="w-auto"
              vs-justify="center"
            >
              <vs-row vs-type="flex" vs-w="12">
                <vs-col v-if="$isCenterBranch() || $isRegionalCenterBranch()" vs-type="flex" class="w-auto">
                  <vx-tooltip text="Yeni Şube" position="top">
                    <vs-button
                      @click="addNewData"
                      class="panel-action text-success xlarge-button panel-action-box-shadow"
                      color="transparent"
                      icon-pack="feather"
                      icon="icon-plus"
                    >
                    </vs-button>
                  </vx-tooltip>
                </vs-col>
                <vs-col vs-type="flex" class="w-auto">
                  <vx-tooltip text="Detaylı Filtereleme" position="top">
                    <vs-button
                      @click="isFilterActive = !isFilterActive"
                      class="panel-action text-warning xlarge-button panel-action-box-shadow"
                      color="transparent"
                      icon-pack="pickicon"
                      icon="icon-pick-filter"
                    >
                    </vs-button>
                  </vx-tooltip>
                </vs-col>
                <vs-col vs-type="flex" class="w-auto">
                  <vx-tooltip text="Excel Export" position="top">
                    <vs-button
                      @click="getExcel"
                      class="panel-action text-dark xlarge-button panel-action-box-shadow"
                      color="transparent"
                      icon-pack="feather"
                      icon="icon-download"
                    >
                    </vs-button>
                  </vx-tooltip>
                </vs-col>
                <vs-col v-if="$isCenterBranch()" vs-type="flex" class="w-auto">
                  <vx-tooltip text="Tüm Şube Stoklarını Eşitle" position="top">
                    <vs-button
                      @click="syncStocks(null)"
                      class="panel-action text-primary xlarge-button panel-action-box-shadow"
                      color="transparent"
                      icon-pack="feather"
                      icon="icon-refresh-cw"
                    >
                    </vs-button>
                  </vx-tooltip>
                </vs-col>
              </vs-row>
            </vs-col>
            <vs-col id="filter-chips" vs-type="flex">
              <vs-row
                vs-type="flex"
                vs-w="12"
                vs-justify="center"
                vs-align="center"
              >
                <vs-button
                  id="clearFilterButton"
                  v-if="filterChips.length > 0"
                  @click="clearFilter"
                  class="mr-2 bg-white text-danger panel-action-box-shadow"
                  icon-pack="feather"
                  icon="icon-slash"
                  radius
                  color="transparent"
                />
                <vs-col
                  vs-type="flex"
                  class="w-auto"
                  v-for="(chip, index) in filterChips"
                  :key="index"
                >
                  <vs-chip
                    color="white"
                    class="panel-action-box-shadow px-1"
                    @click="removeFilter(chip.col, index)"
                    v-show="chip.value != ''"
                    closable
                  >
                    <vs-row vs-tpye="flex" vs-w="12">
                      <vs-col vs-tpye="flex" class="w-auto" vs-align="center">
                        <span class="bold text-xsmaller text-dark">
                          {{ chip.name + " :" }}
                        </span>
                      </vs-col>
                      <vs-col
                        vs-type="flex"
                        class="w-auto ml-1"
                        vs-align="center"
                      >
                        <span
                          class="weight-600 italic text-xsmaller text-primary"
                        >
                          {{ chip.value }}
                        </span>
                      </vs-col>
                    </vs-row>
                  </vs-chip>
                </vs-col>
              </vs-row>
            </vs-col>
            <vs-col
              id="table-page-size"
              vs-type="flex"
              class="w-auto"
              vs-justify="flex-end"
            >
              <vs-dropdown
                vs-trigger-click
                class="bg-white cursor-pointer panel-action-box-shadow"
              >
                <div
                  class="px-4 d-theme-border-grey-light d-theme-dark-bg cursor-pointer flex items-center justify-between text-small"
                >
                  <span class="mr-2 page-size-dropdown-span"
                    >{{ (currentPage + 1) * itemsPerPage - (itemsPerPage - 1) }}
                    -
                    {{
                      totalDataRow - (currentPage + 1) * itemsPerPage > 0
                        ? (currentPage + 1) * itemsPerPage
                        : totalDataRow
                    }}
                    of
                    {{ totalDataRow }}</span
                  >
                  <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
                </div>
                <!-- <vs-button class="btn-drop" type="line" color="primary" icon-pack="feather" icon="icon-chevron-down"></vs-button> -->
                <vs-dropdown-menu>
                  <vs-dropdown-item @click="itemsPerPage = 10">
                    <span>10</span>
                  </vs-dropdown-item>
                  <vs-dropdown-item @click="itemsPerPage = 15">
                    <span>15</span>
                  </vs-dropdown-item>
                  <vs-dropdown-item @click="itemsPerPage = 20">
                    <span>20</span>
                  </vs-dropdown-item>
                </vs-dropdown-menu>
              </vs-dropdown>
            </vs-col>
          </vs-row>
        </vs-row>
      </div>

      <template slot="thead">
        <vs-th class="w-1/12">
          <vs-button
            class="p-1 weight-600"
            icon-pack="feather"
            :icon="tableOptions.sortBy == 'Id' ? sortingHeadIcon : null"
            color="primary"
            type="flat"
            @click="setSortingOptions('Id')"
            >No
          </vs-button>
        </vs-th>
        <vs-th class="w-1/12">
          <vs-button
            class="p-1 weight-600"
            icon-pack="feather"
            :icon="tableOptions.sortBy == 'branchCode' ? sortingHeadIcon : null"
            color="primary"
            type="flat"
            @click="setSortingOptions('branchCode')"
            >Kod
          </vs-button>
        </vs-th>
        <vs-th class="w-2/12">
          <vs-button
            class="p-1 weight-600"
            icon-pack="feather"
            :icon="tableOptions.sortBy == 'name' ? sortingHeadIcon : null"
            color="primary"
            type="flat"
            @click="setSortingOptions('name')"
            >İsim
          </vs-button>
        </vs-th>
        <vs-th class="w-1/12">
          <vs-button
            class="p-1 weight-600"
            icon-pack="feather"
            :icon="
              tableOptions.sortBy == 'branchOwner.FirstName'
                ? sortingHeadIcon
                : null
            "
            color="primary"
            type="flat"
            @click="setSortingOptions('branchOwner.FirstName')"
            >Yetkili
          </vs-button>
        </vs-th>
        <vs-th class="w-1/12">
          <vs-button
            class="p-1 weight-600"
            icon-pack="feather"
            :icon="
              tableOptions.sortBy == 'state.City.Name' ? sortingHeadIcon : null
            "
            color="primary"
            type="flat"
            @click="setSortingOptions('state.City.Name')"
            >Şehir
          </vs-button>
        </vs-th>
        <vs-th class="w-1/12">
          <vs-button
            class="p-1 weight-600"
            icon-pack="feather"
            :icon="tableOptions.sortBy == 'state.Name' ? sortingHeadIcon : null"
            color="primary"
            type="flat"
            @click="setSortingOptions('state.Name')"
            >İlçe
          </vs-button>
        </vs-th>
        <vs-th class="w-1/12">
          <vs-button
            color="primary"
            class="opacity-full p-1 weight-600"
            disabled="true"
            type="flat"
            >Telefon</vs-button
          >
        </vs-th>
        <vs-th class="w-1/12">
          <vs-button
            color="primary"
            class="opacity-full p-1 weight-600"
            icon-pack="feather"
            :icon="
              tableOptions.sortBy == 'created' ? sortingHeadIcon : null
            "
            @click="setSortingOptions('created')"
            type="flat"
            >Oluş. Tar.</vs-button
          >
        </vs-th>
        <vs-th class="w-1/12">
          <vs-button
            color="primary"
            class="opacity-full p-1 weight-600"
            disabled="true"
            type="flat"
            >Durum</vs-button
          >
        </vs-th>
        <vs-th class="w-2/12" v-if="$isCenterBranch() || $isRegionalCenterBranch()">
          <vs-button
            color="primary"
            class="opacity-full p-1 weight-600"
            disabled="true"
            type="flat"
            >İşlem</vs-button
          >
        </vs-th>
      </template>

      <template slot-scope="{ data }">
        <tbody style="text-align: center">
          <vs-tr :data="tr" :key="tr.id" v-for="(tr, indextr) in data">
            <vs-td class="w-1/12">
              <p class="text-center">{{ tr.id }}</p>
            </vs-td>
            <vs-td class="w-1/12">
              <p class="text-center">{{ tr.branchCode }}</p>
            </vs-td>

            <vs-td class="w-2/12">
              <div class="flex items-center justify-center">
                <vx-tooltip v-if="tr.isCenter" text="Merkez Şube" position="top">
                  <feather-icon icon="StarIcon" svgClasses="w-4 h-4 text-warning fill-current mr-1" />
                </vx-tooltip>
                <p class="text-center">{{ tr.name }}</p>
              </div>
            </vs-td>

            <vs-td class="w-1/12">
              <p class="text-center">
                {{ tr.branchOwner.firstName }}
              </p>
            </vs-td>

            <vs-td class="w-1/12">
              <p class="text-center">{{ tr.state.city.name }}</p>
            </vs-td>

            <vs-td class="w-1/12">
              <p class="text-center">{{ tr.state.name }}</p>
            </vs-td>

            <vs-td class="w-1/12">
              <p class="text-center">{{ tr.phoneNumber }}</p>
            </vs-td>
            <vs-td class="w-1/12">
              <p class="text-center">{{ tr.createdDate }}</p>
            </vs-td>
            <vs-td class="w-1/12">
              <div class="flex justify-center" @click.stop>
                <vs-switch
                  :value="tr.active !== false && tr.Active !== false"
                  @click.native.stop
                  @input="toggleBranchStatus(tr)"
                  color="success"
                />
              </div>
            </vs-td>

            <vs-td class="w-2/12 actionIconRow" v-if="$isCenterBranch() || $isRegionalCenterBranch()">
              <vs-row vs-type="flex" vs-w="12" vs-justify="space-between">
                <vs-col vs-type="flex" vs-w="3">
                  <vx-tooltip text="Stokları Sıfırla" position="top">
                    <feather-icon
                      icon="RotateCcwIcon"
                      svgClasses="w-5 h-5 hover:text-danger stroke-current"
                      @click.stop="
                        resetId = tr.id;
                        resetPopupActive = true;
                      "
                    />
                  </vx-tooltip>
                </vs-col>
                <vs-col vs-type="flex" vs-w="4">
                  <vx-tooltip
                    v-if="tr.id != 1"
                    :text="tr.name + ' Stoklarını Eşitle'"
                    position="top"
                  >
                    <feather-icon
                      icon="RefreshCwIcon"
                      svgClasses="w-5 h-5 text-primary stroke-current"
                      @click.stop="syncStocks(tr.id)"
                    />
                  </vx-tooltip>
                </vs-col>
                <vs-col vs-type="flex" vs-w="4">
                  <vx-tooltip
                    v-if="tr.id != 1 && isDeleteBranchPermission"
                    text="Şubeyi Sil"
                    position="top"
                  >
                    <feather-icon
                      icon="TrashIcon"
                      svgClasses="w-5 h-5 text-danger stroke-current"
                      @click.stop="
                        deletedId = tr.id;
                        deletePopupActive = true;
                      "
                    />
                  </vx-tooltip>
                </vs-col>
              </vs-row>
            </vs-td>
          </vs-tr>
        </tbody>
      </template>
    </vs-table>
    <pagination-default
      :setCurrentPage="tableOptions.pageIndex"
      :totalLenght="calculatePageLength"
      @currentPage="getCurrentPage"
    ></pagination-default>
  </div>
</template>

<script>
import GlobalFilter from "../GlobalFilter";
import moduleBranch from "@/store/branch/moduleBranch.js";
import PaginationDefault from "../PaginationDefault";
import DataViewSidebar from "./NewBranchAdd.vue";
import { deleteBranch, getExcel, syncStocks, resetBranch, getExcelForDealer, updateBranch } from "@/api/Branch";
import {isGranted} from "@/utils/auth";
/* eslint-disable */

export default {
  components: {
    DataViewSidebar,
    PaginationDefault,
    GlobalFilter,
  },
  data() {
    return {
      deletePopupActive: false,
      deletedId: null,
      resetPopupActive: false,
      resetId: null,
      selected: "",

      tableOptions: {},
      sortingHeadIcon: "",
      sortingHeadIconBool: 1,
      currentPage: 0,
      itemsPerPage: 10,

      addNewDataSidebar: false,
      sidebarData: {},

      isFilterActive: false,
      filterOptions: [
        "branchCode",
        "branch",
        "city",
        "state",
        "branchEmail",
        "branchPhoneNumber",
        "branchAddress",
        "active",
      ],
      filterOptionNames: [
        "Kod",
        "İsim",
        "Şehir",
        "İlçe",
        "Email",
        "Telefon",
        "Adres",
        "Durum",
      ],
      filterChips: [],
    };
  },
  computed: {
    branches() {
      return this.$store.state.branch.branches;
    },
    totalDataRow() {
      return this.$store.state.branch.totalDataRow;
    },
    calculatePageLength() {
      let mod = this.totalDataRow % this.itemsPerPage;
      return mod > 0
        ? (this.totalDataRow - mod) / this.itemsPerPage + 1
        : this.totalDataRow / this.itemsPerPage;
    },
    isNewBranchPermission(){
      return isGranted("branch_write")
    },
    isDeleteBranchPermission(){
      return isGranted("branch_delete")
    }
  },
  methods: {
    syncStocks(id) {
      syncStocks(id)
        .then((res) => {
          if (res && res.status === 200) {
            this.$vs.notify({
              color: "success",
              title: "İşlem Başarılı !",
              text: "Stok Eşitleme Başarılı.",
            });
          } else {
            this.$vs.notify({
              color: "danger",
              title: "Hata : " + res.status,
              text: "Excel Export İşlemi Başarısız !",
            });
          }
        })
        .catch(() => {
          this.$vs.notify({
            color: "danger",
            title: "Hata !",
            text: "Sunucu Bağlantı Hatası",
          });
        });
    },
    getExcel() {
      if (this.$isRegionalCenterBranch()) {
        getExcelForDealer(this.tableOptions)
        .then((res) => {
          if (res && res.status == 200) {
            const url = window.URL.createObjectURL(new Blob([res.data]));
            const link = document.createElement("a");
            link.href = url;
            let now = this.$now.date();
            link.setAttribute(
              "download",
              "Şube Listesi" +
                now.getDate() +
                " " +
                this.$months()[now.getMonth()].name +
                " " +
                now.getFullYear() +
                ".xlsx"
            );
            document.body.appendChild(link);
            link.click();

            this.$vs.notify({
              color: "success",
              title: "Başarılı",
              text: "Excel Export Başarılı !",
            });
          } else {
            this.$vs.notify({
              color: "danger",
              title: "Hata : " + res.status,
              text: "Excel Export İşlemi Başarısız !",
            });
          }
        })
        .catch(() => {
          this.$vs.notify({
            color: "danger",
            title: "Hata !",
            text: "Sunucu Bağlantı Hatası !",
          });
        });
      } else {
        getExcel(this.tableOptions)
        .then((res) => {
          if (res && res.status == 200) {
            const url = window.URL.createObjectURL(new Blob([res.data]));
            const link = document.createElement("a");
            link.href = url;
            let now = this.$now.date();
            link.setAttribute(
              "download",
              "Şube Listesi" +
                now.getDate() +
                " " +
                this.$months()[now.getMonth()].name +
                " " +
                now.getFullYear() +
                ".xlsx"
            );
            document.body.appendChild(link);
            link.click();

            this.$vs.notify({
              color: "success",
              title: "Başarılı",
              text: "Excel Export Başarılı !",
            });
          } else {
            this.$vs.notify({
              color: "danger",
              title: "Hata : " + res.status,
              text: "Excel Export İşlemi Başarısız !",
            });
          }
        })
        .catch(() => {
          this.$vs.notify({
            color: "danger",
            title: "Hata !",
            text: "Sunucu Bağlantı Hatası !",
          });
        });
      }
      
    },
    saveOptions(filterOptions, filterChips) {
      this.isFilterActive = false;
      if (_.isEqual(this.tableOptions, filterOptions)) return;
      this.tableOptions = _.cloneDeep(filterOptions);
      this.filterChips = _.cloneDeep(filterChips);
    },
    clearFilter() {
      this.tableOptions = {
        sortBy: "Name",
        sortDirection: "asc",
        pageIndex: 0,
        pageSize: this.itemsPerPage,
        branchCode: null,
        branch: null,
        city: null,
        state: null,
        branchEmail: null,
        branchPhoneNumber: null,
        branchAddress: null,
        active: null,
      };
      this.filterChips.length = 0;
    },
    removeFilter(col, index) {
      this.tableOptions[col] = null;
      this.filterChips.splice(index, 1);
    },
    escape() {
      if (this.deletePopupActive) {
        this.deletePopupActive = false;
        this.deletedId = null;
      }
    },
    addNewData() {
      this.sidebarData = {};
      this.toggleDataSidebar(true);
    },
    deleteData(id) {
      deleteBranch(id).then((res) => {
        if (res && res.status == 200) {
          this.$store.dispatch("branch/removeBranch", id).then(() => {
            this.deletePopupActive = false;
            this.$vs.notify({
              color: "success",
              title: "Silme İşlemi",
              text: "Şube Başarıyla Silindi",
            });
          });
        } else {
          this.$vs.notify({
            color: "danger",
            title: "Hata : " + res.status,
            text: "Silme İşlemi Başarısız !",
          });
        }
      });
    },
    resetBranch(id) {
      resetBranch(id).then((res) => {
        if (res && res.status == 200) {
          this.resetPopupActive = false;
          this.resetId = null;
          this.$vs.notify({
            color: "success",
            title: "Sıfırlama İşlemi",
            text: "Şube Başarıyla Sıfırlandı",
          });
        } else {
          this.$vs.notify({
            color: "danger",
            title: "Hata : " + res.status,
            text: "Silme İşlemi Başarısız !",
          });
        }
      });
    },
    editData(data) {
      this.sidebarData = data;
      this.toggleDataSidebar(true);
    },
    getCurrentPage(currentx) {
      this.currentPage = currentx - 1;
    },
    toggleDataSidebar(val = false) {
      this.addNewDataSidebar = val;
      val == false ? (this.selected = "") : null;
    },
    getBranchList() {
      if (this.$isRegionalCenterBranch()) {
        this.$store
        .dispatch("branch/fetchDataListItemsBranchForDealer", this.tableOptions)
        .catch((error) => {
          this.$vs.notify({
            color: "danger",
            title: "Hata",
            text: error,
          });
        });
      } else {
        this.$store
        .dispatch("branch/fetchDataListItemsBranch", this.tableOptions)
        .catch((error) => {
          this.$vs.notify({
            color: "danger",
            title: "Hata",
            text: error,
          });
        });
      }
      
    },
    setSortingOptions(val) {
      if (this.tableOptions.sortBy != val) this.sortingHeadIconBool = 1;
      this.tableOptions.sortBy = val;
      switch (this.sortingHeadIconBool) {
        case 1:
          this.sortingHeadIconBool++;
          this.sortingHeadIcon = "icon-arrow-up";
          break;
        case 2:
          this.sortingHeadIconBool++;
          this.sortingHeadIcon = "icon-arrow-down";
          break;
        case 3:
          this.sortingHeadIconBool = 1;
          this.sortingHeadIcon = "";
          this.tableOptions.sortBy = "";
      }
    },
    toggleBranchStatus(branch) {
      let updatedBranch = _.cloneDeep(branch);
      let nextStatus = (branch.active === false || branch.Active === false) ? true : false;
      updatedBranch.active = nextStatus;
      updatedBranch.Active = nextStatus;
      updateBranch(updatedBranch)
        .then((res) => {
          if (res && res.status == 200) {
            this.$vs.notify({
              color: "success",
              title: "Başarılı",
              text: "Şube Durumu Güncellendi",
            });
            this.$store.dispatch("branch/fetchDataListItemsBranch", this.tableOptions);
          } else {
            this.$vs.notify({
              color: "danger",
              title: "Hata",
              text: "Güncelleme İşlemi Başarısız !",
            });
          }
        }).catch(() => {
          this.$vs.notify({
            color: "danger",
            title: "Hata",
            text: "Sunucu Bağlantı Hatası!",
          });
        });
    },
  },
  created() {
    if (!moduleBranch.isRegistered) {
      this.$store.registerModule("branch", moduleBranch);
      moduleBranch.isRegistered = true;
    }
    document.body.addEventListener("keyup", (e) => {
      if (e.keyCode === 13) {
        if (this.deletePopupActive) this.deleteData(this.deletedId);
      }
    });
    this.clearFilter();
  },
  watch: {
    tableOptions: {
      deep: true,
      handler(val) {
        this.$nextTick(() => {
          this.getBranchList();
        });
      },
    },
    selected: function (val) {
      if (val != "" && (this.$isCenterBranch() || this.$isRegionalCenterBranch())) this.editData(val);
    },
    currentPage: function (val) {
      this.tableOptions.pageIndex = val;
    },
    sortingHeadIconBool: function () {
      switch (this.sortingHeadIconBool) {
        case 1:
          this.tableOptions.sortDirection = "";
          break;
        case 2:
          this.tableOptions.sortDirection = "asc";
          break;
        case 3:
          this.tableOptions.sortDirection = "desc";
          break;
      }
      this.currentPage = 0;
      this.tableOptions.pageIndex = this.currentPage;
    },
    itemsPerPage: function (val) {
      this.currentPage = 0;
      this.tableOptions.pageSize = val;
      this.tableOptions.pageIndex = this.currentPage;
    },
  },
};
</script>

<style>
#branchDataList .con-tablex {
  max-height: calc(100vh - 215px);
  overflow-y: auto;
}
</style>
